import styles from "./ConsultingDetail.module.css";
import SubPageTop from "../../components/SubPageTop";
import ScrollReveal from "../../components/Ui/ScrollReveal";
import { FiMessageSquare, FiCheckSquare, FiFeather } from "react-icons/fi";
import React from "react";
const steps = [
  {
    icon: <FiMessageSquare size={32} color="#ff5670" />,
    title: "01 컨설팅 목적 상담",
    desc: [
      "퍼스널 컬러 컨설팅이 필요한 이유와 비즈니스 영역 상담으로 방향 설정",
    ],
  },
  {
    icon: <FiCheckSquare size={32} color="#ff5670" />,
    title: "02 베이스/명암/청틱 진단",
    desc: [
        "80여가지 드레이프를 이용하여 웜/쿨, 청/탁, 명/암 구분하여 진단",
        "진단 결과를 진단 카드와 계절별 스타일링 카드에 체크",
      ],
  },
  {
    icon: <FiFeather size={32} color="#ff5670" />,
    title: "03 스타일 전반 컨설팅",
    desc: [
        "진단 결과에 맞춘 헤어, 패션,악세서리, 메이크업 컬러 제안",
      ],
  },
];

function PersonalColor() {
  return (
    <div className={styles.consultingDetail}>
      <SubPageTop title="Consulting" />
      <div className={styles.consultingDetailContent}>
        <ScrollReveal>
          <section className={styles.section01}>
          <div className={styles.imgbox}>
            <img
              src="/image/consulting-detail-section01-06.png"
              alt="컬러 이미지"
            />
          </div>
          <div className={styles.infoBox}>
            <div className={styles.infoHeader}>
              <p className={styles.subtitle}>Color Consulting</p>
              <p className={styles.koTitle}>퍼스널 컬러 컨설팅</p>
            </div>
            <div className={styles.infoDetail}>
              <div className={styles.infoDesc}>
                퍼스널 컬러 컨설팅은,
                <br />
                타고난 신체색상과 조화를 이루며 라이프 스타일에 맞는 컬러 이미지
                전략을 제안하는 프로그램 입니다.
              </div>
             <ul className={styles.infoList}>
                <li>
                  <span className={styles.pointcolor}>✓</span>
                  <span>
                    사전상담
                  </span>
                </li>
                <li>
                  <span className={styles.pointcolor}>✓</span>
                  <span>
                    방문 컨설팅
                  </span>
                </li>
                <li>
                  <span className={styles.pointcolor}>✓</span>
                  <span>
                    스타일링 제안
                  </span>
                </li>
              </ul> 
            </div>
          </div>
        </section>
        </ScrollReveal>
        <ScrollReveal>
          <section className={styles.section02}>
          <div className={styles.titleWrap}>
            <p className={styles.programSubtitle}>process</p>
            <h2 className={styles.title}>컨설팅 프로세스</h2>
          </div>
          <div className={styles.line}></div>
          <div className={styles.steps}>
            {steps.map((step, i) => (
              <React.Fragment key={i}>
                <div className={styles.step}>
                  <div className={styles.iconWrap}>{step.icon}</div>
                  <div className={styles.textWrap}>
                    <div className={styles.stepTitle}>{step.title}</div>
                    <div className={styles.stepDesc}>
                      <div className={styles.stepDesc}>
                        {Array.isArray(step.desc) ? (
                          <ul>
                            {step.desc.map((text, idx) => (
                              <li key={idx}>{text}</li>
                            ))}
                          </ul>
                        ) : (
                          step.desc
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {i < steps.length - 1 && (
                  <div className={styles.arrowWrap}>
                    <img
                      src="/image/arrow_right.png"
                      alt="arrow_right"
                      className={styles.arrow}
                    />
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </section>
        </ScrollReveal>
      </div>
    </div>
  );
}

export default PersonalColor;
